import isEmpty from "lodash/isEmpty";
import cloneDeep from "lodash/cloneDeep";
import { orgInfoArr } from "./propType";

// 树形右选时参数处理
export function getExtraParams(data = []) {
  const { type, dataParams = {}, form } = this.props;
  const {
    isAccount,
    checkStrictly,
    leftTreeCheckedData,
    leftGroupCheckedData,
    leftTreeCheckedKeys,
    companyId
  } = this.state;
  let params = {
    ...([167, 168, 169, 170].indexOf(Number(type)) !== -1 ? dataParams : {}),
    ...(form ? this.getFormParams() : {})
  };
  let leftCheckedData = [...leftTreeCheckedData, ...data];
  let leftCheckedKeys = [...leftTreeCheckedKeys];
  if (!checkStrictly) params.alllevel = 1;
  if (orgInfoArr.findIndex(t => t == type) > 0) {
    // 多分部
    params.types = leftCheckedData
      .map(data => `${data.type == "1" ? "subcom" : "dept"}|${data.id}`)
      .join(",");
  }
  if (type == "142") {
    // 收发文单位，树形数据特殊处理
    params = {
      ...params,
      types: leftCheckedData.map(d => `${d.type}|${d.id}`).join(","),
      checkStrictly
    };
  } else if (this.isCrm()) {
    leftCheckedData = [...leftCheckedData, ...leftGroupCheckedData];
    this.resourcesCache = {};
    leftCheckedData.map(item => {
      this.resourcesCache[item.type + item.id] = item;
    });
    params.cmd = "resource";
    params.types = leftCheckedData
      .map(d => (d.type && d.type !== "resource" ? `${d.type}|${d.id}` : d.id))
      .join(",");
    if (isAccount) params["isNoAccount"] = 1;
  } else {
    params = {
      ...params,
      selectids: leftCheckedKeys.join(","),
      virtualCompanyid: companyId || "1"
    };
  }
  return params;
}

// 获取人力资源特殊参数
export function getHrmParams(activeKey, companyId) {
  const { type } = this.props;
  if (type != 1 && type != 17) return {};
  const { isAccount, showAllbranch } = this.state;
  if (activeKey == undefined) {
    activeKey = this.state.activeKey;
  } else {
    companyId = 0;
  }
  let params = {};
  if (activeKey == "1") {
    params.cmd = "newly"; // 最近
  } else if (activeKey == "2") {
    params.cmd = "underling"; //同部门
  } else if (activeKey == "3") {
    params.cmd = "branch"; //我的下属
    if (showAllbranch) params["alllevel"] = 1;
  } else if (activeKey == "4" || activeKey == "5") {
    params = {
      ...params,
      ...this.defaultConditionParams
    };
    params.cmd = activeKey == "5" ? "v2grouptree" : "v2resourcetree"; // 常用组 或 组织结构
  } else if (activeKey == "") {
    params.cmd = "search"; // 搜索
  }
  if (isAccount) params.isNoAccount = 1;
  if (companyId) params.virtualtype = companyId;
  return params;
}

// 处理高级搜索参数
export function getFormParams() {
  const { form } = this.props;
  if (!form) return {};
  let fieldNames = [];
  const formParams = {};
  let formFields = form.getFields() || [];
  for (const key in formFields) {
    if (formFields.hasOwnProperty(key)) {
      fieldNames.push(key);
    }
  }
  const newObject = cloneDeep(form.getFieldsValue(fieldNames));
  Object.keys(newObject).forEach(key => {
    const value = newObject[key];
    if (value || value === 0 || value === false) formParams[key] = value;
  });
  return formParams;
}

// 获取树形异步加载的地址和参数
export function getAsyncParams(activeKey) {
  const { dataURL, type, dataParams, form } = this.props;
  const tabs = this.getTabs();
  let url = `${dataURL}${type}`;
  let asyncOtherParams = { ...dataParams };
  let tab = {};
  const otherParams = {};
  activeKey = activeKey || this.state.activeKey;
  if (!isEmpty(tabs)) {
    tab = tabs.filter(m => m.key == activeKey)[0];
  }
  if (tab) {
    url = tab.url || url;
    asyncOtherParams = {
      ...asyncOtherParams,
      ...(tab.dataParams || {})
    };
  }
  if (orgInfoArr.indexOf(type + "") !== -1) {
    const companyId = this.state.companyId || "1";
    otherParams["virtualCompanyid"] = companyId;
  }
  if (this.isCrm()) {
    const companyId = this.state.companyId || "1";
    otherParams["virtualtype"] = companyId;
  }
  asyncOtherParams = {
    ...asyncOtherParams,
    ...(form ? this.getFormParams() : {}),
    ...this.getHrmParams(),
    ...otherParams
  };
  return { dataUrl: url, asyncOtherParams };
}

// 获取搜索的参数
export function getSearchParams(customParams) {
  const { dataParams, hasAdvanceSerach, form, isSingle } = this.props;
  const { inputValue, activeKey, date2during } = this.state;
  const tabs = this.getTabs();
  const quickSearch = this.state.quickSearch || "name";
  let params = {};
  let tabsDataParams = {};
  if (((isSingle && hasAdvanceSerach) || !isSingle) && form) {
    params = { ...params, ...this.getFormParams() };
  }
  if (quickSearch && inputValue) {
    params[quickSearch] = inputValue;
    form.setFieldsValue({ [quickSearch]: inputValue });
  }
  if (date2during) {
    params.date2during = date2during;
  }
  if (!isEmpty(tabs) && activeKey) {
    tabsDataParams =
      tabs.filter(tab => tab.key === activeKey)[0].dataParams || {};
  }
  return {
    ...params,
    ...dataParams,
    ...tabsDataParams,
    ...customParams
  };
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/browser/getParams.js